export const PENDING_CHANGES_NOTIFICATION_ID = 'pending-changes';

export const DATASET_ACTION_GROUP = 'Dataset';

export const GRAPH_ACTION_GROUP = 'Graph';

export const DATASET_EDITOR_ACTION_GROUP = 'Editor';
